import { StringUtils } from './string.utils';

export class ValidatorUtils {

    protected static selections = [ 'checkbox', 'radio', 'select' ];

    /**
    * Validation Attribute @see html5 validation
    */
    protected  static attributes = {
        required: 'required',
        min: 'min',
        minLength: 'minlength',
        max: 'max',
        maxLength: 'maxlength',
        pattern: 'pattern',
    };

    protected static executeRegExp(pattern: string, value: any): boolean {
        const regexp = new RegExp(pattern);
        return !regexp.test(value); // 반환값이 true 일 때 메세지가 지정되므로, 실행결과를 반대로 반환한다.
    }

    public static isSelection(type: string): boolean {
        return (this.selections.indexOf(type) >= 0);
    }

    public static validNumber(element: any): boolean {
        if (element.type === 'number') {
            return this.executeRegExp('/^[0-9]$/g', element.value);
        } else {
            return false;
        }
    }

    public static validEmail(element: any): boolean {
        if (element.type === 'email') {
            return this.executeRegExp('/^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{2,5}$/g', element.value);
        } else {
            return false;
        }
    }

    public static validCheckbox(element: any): boolean {
        if (element.checked) {
            return false;
        } else {
            return true;
        }
    }

    public static validRadio(element: any): boolean {
        /**
         * 차후 라디오 그룹에 대한 Validation 구현할 것!
         * 현재는 interface 만 정의
         */
        return false;
    }

    public static validSelect(element: any): boolean {
        /**
         * 차후 <select>에 대한 Validation 구현할 것!
         * 현재는 interface 만 정의
         */
        return false;
    }

    public static checkRequired(attr: any, element: any): boolean {
        const attribute: string = attr.name.toLowerCase();
        let isValid = false;
        if (attribute === this.attributes.required) {
            if (this.isSelection(element.type)) {
                switch (element.type) {
                    case this.selections[0]:
                        isValid = this.validCheckbox(element);
                        break;
                    case this.selections[1]:
                        isValid = this.validRadio(element);
                        break;
                    case this.selections[2]:
                        isValid = this.validSelect(element);
                        break;
                }
            } else {
                isValid = StringUtils.isEmpty(element.value);
            }
        }
        return isValid;
    }

    public static checkMinimum(attr: any, value: any): boolean {
        const attribute: string = attr.name.toLowerCase();
        if (attribute === this.attributes.min || attribute === this.attributes.minLength) {
            return (value.length < attr.value);
        }
    }

    public static checkMaximum(attr: any, value: any): boolean {
        const attribute: string = attr.name.toLowerCase();
        if (attribute === this.attributes.max || attribute === this.attributes.maxLength) {
            return (value.length > attr.value);
        }
    }

    public static checkPattern(attr: any, value: any): boolean {
        const attribute: string = attr.name.toLowerCase();
        if (attribute === this.attributes.pattern) {
            return this.executeRegExp(attr.value, value);
        }
    }

    public static checkMinNum(val: any, min: any) {
        if (val !== undefined && val.length < min) {
            return true;
        } else {
            return false;
        }
    }

    public static checkMaxNum(val: any, max: any) {
        if (val !== undefined && val.length > max) {
            return true;
        } else {
            return false;
        }
    }

    public static checkMinMaxNum(val: any, min: any, max: any): boolean {
        if (this.checkMinNum(val, min) || this.checkMaxNum(val, max)) {
            return true;
        } else {
            return false;
        }
    }

    public static checkTime(val: any): boolean {
        const exp = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
        return exp.test(val);
    }

    public static checkDate(val: any): boolean {
        const exp = /^(19|20)\d{2}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[0-1])$/;
        return exp.test(val);
    }

    public static checkNumberValidation(event) {
        let value = event.target.value;
        const defaultVal = event.target.getAttribute('val');
        const min = event.target.min;
        const max = event.target.max;

        if (value === null || value === undefined || value.trim() === '' || value.trim() === '0') {
            value = defaultVal === null ? min : defaultVal;
        }

        value = Number(value.replace(/[^0-9]/g, ''));

        if (value < min) {
            value = defaultVal === null ? min : defaultVal;
        }
        if (value > max ) {
            value = defaultVal === null ? max : defaultVal;
        }
        event.target.value = value;
        return;
    }

    public static onlyNumber(event) {
        const keyID = event.keyCode;
        if ((keyID >= 48 && keyID <= 57) || (keyID >= 96 && keyID <= 105) || keyID === 8 || keyID === 13 || keyID === 46 || (keyID >= 37 && keyID <= 40) ) {
            return true;
        } else {
            return false;
        }

    }

    public static removeChar(event) {
        const keyID = event.keyCode;
        if (keyID === 8 || keyID === 46 || (keyID >= 37 && keyID <= 40) ) {
            return;
        } else {
            event.target.value = event.target.value.replace(/[^0-9]/g, '');
            return;
        }
    }

    //hh:mm 형태로 입력받기위해 숫자와 : 만 입력 가능 하도록 처리
    public static onlyTime(event) {
        const keyID = event.keyCode;
        if ((keyID >= 48 && keyID <= 57) || (keyID >= 96 && keyID <= 105) || keyID === 8 || keyID === 13 || keyID === 46 || (keyID >= 37 && keyID <= 40)) {
            return true;
        } else if (keyID === 186 && event.shiftKey) {
            return true;
        } else {
            return false;
        }
    }

    //YYYY-MM-DD 형태로 입력받기위해 숫자와 - 만 입력 가능 하도록 처리
    public static onlyDate(event) {
        const keyID = event.keyCode;
        if ((keyID >= 48 && keyID <= 57) || (keyID >= 96 && keyID <= 105) || keyID === 8 || keyID === 13 || keyID === 46 || (keyID >= 37 && keyID <= 40) || keyID === 109 || keyID === 189) {
            return true;
        } else {
            return false;
        }
    }

    // email key 에 영문/숫자/특수문자 3개만 입력 가능
    public static onlyEmailKey(event) {
        event.target.value = event.target.value.replace(/[^0-9a-zA-Z.\-_]/g, '');
        return;
    }

    public static checkURL(val: any): boolean {
        // const urlRegExp = /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/;
        const urlRegExp = /((((https?):\/\/))(%[0-9A-Fa-f]{2}|[-()_.!~*';\/?:@&=+$,A-Za-z0-9])+)([).!';\/?:,][[:blank:|:blank:]])?/;
        if (urlRegExp.test(val)) {
            return true;
        } else {
            return false;
        }
        // ^((((https?|ftps?|gopher|telnet|nntp)://)|(mailto:|news:))(%[0-9A-Fa-f]{2}|[-()_.!~*';/?:@&=+$,A-Za-z0-9])+)([).!';/?:,][[:blank:|:blank:]])?$
    }

  constructor() {}

}



// WEBPACK FOOTER //
// ./src/app/shared/utils/src/validator.utils.ts